import SText from "@/styles/SText";
import { ShipAddress, ShipAddressDefault } from "@/types/shipAddress";
import { Flex, Select, SelectProps, Tag } from "antd";
import { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";

interface IProps extends Omit<SelectProps, "options"> {
  list: Array<ShipAddress>;
}

const SelectShipAddress: FC<IProps> = ({ list, ...resProps }) => {
  const { t } = useTranslation();
  const renderOption = useCallback((address: ShipAddress) => {
    return {
      key: address.id,
      value: address.id,
      label: (
        <Flex gap={6}>
          <SText tagMode text={address.name} style={{ maxWidth: 200 }} />
          <SText text={address.address} style={{ maxWidth: 200 }} />
          {address.default === ShipAddressDefault.Yes && <Tag color="green" >{t('sale.defaultAddress')}</Tag>}
        </Flex>
      )
    }
  }, [list]);
  return (
    <Select
      {...resProps}
      placeholder={t('sale.shipAddress')}
      options={list.map(renderOption)}
    />
  )
};

export default SelectShipAddress;
